import React, { useState, useEffect } from 'react'
import { Tag, Button } from 'antd'
import { SignalFilled, StarOutlined } from '@ant-design/icons'

export const JobGroup = ({ group, groupId }) => {
  const [jobstatus, setJobstatus] = useState(groupId)
  const [fontcolor, setFontColor] = useState()

  useEffect(() => {
    switch (groupId) {
      case -2:
        setFontColor('red')
        break
      case -1:
        setFontColor('red')
        break
      case 1:
        setFontColor('#068a1a')
        break
      case 2:
        setFontColor('#068a8a')
        break
      case 3:
        setFontColor('#797a7a')
        break
    }
  })

  return (
    <React.Fragment>
      <Tag
        size="small"
        style={{
          minWidth: 100,
          textAlign: 'left',
          color: fontcolor,
          fontSize: '0.7rem'
        }}
        type="text"
        color="blue"
        icon={<StarOutlined />}
      >
        {group ? group.name : null}
      </Tag>
    </React.Fragment>
  )
}
